export default __webpack_public_path__ + "static/media/sword1.730e9a7c.svg";